import React from 'react'
import SupportPrivacyPolicy from '../support-privacy-policy'

const SupportPrivacyPolicyEs = () => {
    return <SupportPrivacyPolicy languageCode="es" />
}

export default SupportPrivacyPolicyEs
